import React from "react";
import { Typography, Grid, Card, CardContent, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import VillaIcon from "@mui/icons-material/Villa";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import "./Services.css"; // Ensure this CSS file exists

const services = [
  {
    icon: <HomeWorkIcon className="service-icon" />,
    title: "Residential House Construction",
    description: "Custom-designed homes built with superior-quality materials, ensuring structural stability through soil testing and material certification.",
  },
  {
    icon: <VillaIcon className="service-icon" />,
    title: "Luxury Villa Construction",
    description: "Premium villa projects with elegant designs and certified material strength, offering sustainable and energy-efficient living.",
  },
  {
    icon: <BuildIcon className="service-icon" />,
    title: "Renovation & Remodeling",
    description: "Upgrade and modernize your space with high-quality, tested materials, ensuring durability and modern aesthetics.",
  },
  {
    icon: <BusinessIcon className="service-icon" />,
    title: "Turnkey Construction Solutions",
    description: "From design to handover, we manage everything—including soil and material testing—for a stress-free experience.",
  },
  {
    title: "Sustainable & Smart Homes",
    description: "Eco-friendly materials, solar solutions, and smart home integration for a future-proof, energy-efficient living experience.",
  },
];

const Services = () => {
  return (
    <div className="services-container">
      <Container maxWidth="lg" className="services-content">
        <Typography variant="h3" className="services-title" gutterBottom>
          Our Services
        </Typography>
        <Typography variant="body1" className="services-subtitle">
          We offer end-to-end residential construction services with certified quality assurance at every stage.
        </Typography>

        <Grid container spacing={4} justifyContent="center" mt={2}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className="service-card">
                <CardContent>
                  <Box className="service-icon-container">{service.icon}</Box>
                  <Typography variant="h6" className="service-card-title">
                    {service.title}
                  </Typography>
                  <Typography variant="body2" className="service-card-description">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default Services;
